// Where the signaling server lives, and which ICE servers to use. All
// overridable via build-time env so deployment can point at a real wss:// host
// and a TURN server without touching code.
//
//   REACT_APP_SIGNALING_URL   e.g. wss://signal.example.com
//   REACT_APP_TURN_URL/_USER/_CRED   optional TURN (needed across networks)
//
// Default: same host as the page on port 8787 (ws for http, wss for https) —
// works when the signaling server runs alongside the app / on the LAN.
export const SIGNALING_URL =
    process.env.REACT_APP_SIGNALING_URL ||
    (typeof window !== 'undefined'
        ? `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${window.location.host}/signaling`
        : 'ws://localhost:8787')

export const ICE_SERVERS = (() => {
    const list = [
        { urls: 'stun:stun.l.google.com:19302' },
        { urls: 'stun:global.stun.twilio.com:3478' },
    ]
    if (process.env.REACT_APP_TURN_URL) {
        list.push({
            urls: process.env.REACT_APP_TURN_URL,
            username: process.env.REACT_APP_TURN_USER || '',
            credential: process.env.REACT_APP_TURN_CRED || '',
        })
    }
    return list
})()

// Short, unambiguous room code (no easily-confused chars).
export function makeRoomCode(len = 6) {
    const alphabet = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'
    let out = ''
    for (let i = 0; i < len; i += 1)
        out += alphabet[Math.floor(Math.random() * alphabet.length)]
    return out
}
